import React, { Fragment, useEffect, useState } from "react";
import { useParams } from 'react-router-dom'
import { Descriptions } from 'antd';

import { Prescription } from "../types/Prescription";
import { fetchPrescriptionById } from "../api/prescription";
import { formatDateToFullString } from "../util/date";
import PrescriptionStatus from "./PrescriptionStatus";
import { prescriptionInitialState } from "../data/state/prescriptions";
import { useTexts } from "../hooks/useTexts";

const PrescriptionPage = () => {
    const { t } = useTexts();
    const [state, setState] = useState<Prescription>(prescriptionInitialState);
    const { id } = useParams();

    useEffect(() => {
        const prescriptionId: number = Number(id);
        fetchPrescriptionById(prescriptionId)
            .then(response => {
                if (!!response) {
                    setState(response)
                }
            })
            .catch(err => console.log(err));
    }, [id]);

    return (
        <div style={{ marginTop: '50px', padding: '16px', background: '#fff', borderRadius: '8px' }}>
            <Descriptions bordered column={1}>
                <Descriptions.Item label={t('prescription', 'product')}>
                    {state.product?.name}
                </Descriptions.Item>
                <Descriptions.Item label={t('prescription', 'user')}>
                    {state.user.firstname + " " + state.user.lastname}
                </Descriptions.Item>
                <Descriptions.Item label={t('prescription', 'mediatorFullname')}>
                    {state.mediator?.place?.name} ({state.mediator?.place?.city})
                </Descriptions.Item>
                <Descriptions.Item label={t('prescription', 'contactNumber')}>
                    {state.phoneNumber} {!!state?.additionalPhoneNumber && ", " + state.additionalPhoneNumber}
                </Descriptions.Item>
                <Descriptions.Item label={t('prescription', 'status')}>
                    <PrescriptionStatus status={state.status} />
                </Descriptions.Item>
                <Descriptions.Item label={t('prescription', 'note')}>
                    {state.note}
                </Descriptions.Item>
                <Descriptions.Item label={t('prescription', 'createdAt')}>
                    {!!state.createdAt ? formatDateToFullString(state.createdAt) : "-"}
                </Descriptions.Item>
                <Descriptions.Item label={t('prescription', 'updatedAt')}>
                    {!!state.updatedAt ? formatDateToFullString(state.updatedAt) : "-"}
                </Descriptions.Item>

                {!!state.productChange?.fromOther && (
                    <Fragment>
                        <Descriptions.Item label={<span style={{ fontWeight: 'bold' }}>{t('productChange', 'toOurProductTitle')}</span>}>
                            {""}
                        </Descriptions.Item>
                        <Descriptions.Item label={t('productChange', 'childMonth')}>
                            {!!state.productChange?.fromOther?.childMonth ? state.productChange?.fromOther?.childMonth : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label={t('productChange', 'initialAssignment')}>
                            {!state.productChange?.fromOther?.initialMedic && !state.productChange?.fromOther?.initialProduct
                                ? "-"
                                : `${state.productChange?.fromOther?.initialMedic ?? ''} ${state.productChange?.fromOther?.initialProduct?.name ?? ''}`
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label={t('productChange', 'toOurProductDate')}>
                            {!!state.productChange?.fromOther?.createdAt
                                ? formatDateToFullString(state.productChange?.fromOther?.createdAt) : "-"}
                        </Descriptions.Item>
                    </Fragment>
                )}

                {!!state.productChange?.toOther && (
                    <Fragment>
                        <Descriptions.Item label={<span style={{ fontWeight: 'bold' }}>{t('productChange', 'toOtherProductTitle')}</span>}>
                            {""}
                        </Descriptions.Item>
                        <Descriptions.Item label={t('productChange', 'childMonth')}>
                            {!!state.productChange?.toOther?.childMonth ? state.productChange?.toOther?.childMonth : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label={t('productChange', 'productChanger')}>
                            {!!state.productChange?.toOther?.productChanger ? state.productChange?.toOther?.productChanger : "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label={t('productChange', 'toOtherProductDate')}>
                            {!!state.productChange?.toOther?.createdAt
                                ? formatDateToFullString(state.productChange?.toOther?.createdAt) : "-"}
                        </Descriptions.Item>
                    </Fragment>
                )}
            </Descriptions>
        </div>
    );
}

export default PrescriptionPage;